module.exports = __webpack_public_path__ + "static/matiaswork5-4c9a4e10b5b233606d3116c462c44a50.jpg";